import styled from 'styled-components';
import { Link as LinkRouter } from 'react-router-dom';

import IconUi from '../../../ui/Icon';

import { colors, spacing, typography } from '../../../../styles/theme';

export const Container = styled.div`
  position: relative;
`;

export const Item = styled.li`
  padding: ${spacing('1')} ${spacing('3')};
  width: calc(100% - 48px);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  &.is-hoverable {
    transition: 0.2s ease-in-out;

    &:hover {
      transition: 0.2s ease-in-out;
      background: ${colors('black.08')};

      a,
      i,
      p {
        transition: 0.2s ease-in-out;
        color: ${colors('black.base')} !important;
      }
    }
  }

  h6 {
    ${typography('bodyLarge')}
    font-weight: 500;

    color: ${colors('black.base')};
  }

  p {
    ${typography('body1')}
    color: ${colors('black.50')};
    transition: 0.2s ease-in-out;
  }

  i {
    transition: 0.2s ease-in-out;
  }
`;

export const List = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  padding: ${spacing('3')} 0px;
`;

export const Link = styled(LinkRouter)`
  ${typography('body1')};

  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 6px;
  color: ${colors('black.50')};
  text-decoration: none;
  box-sizing: border-box;
`;

export const Icon = styled(IconUi)`
  ${typography('body1')};
  width: 24px;
  height: 24px;
  margin-right: ${spacing('extraSmall')};
  padding-top: ${spacing('extraSmall')};
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a3a3a3;
`;

export const Button = styled.button`
  height: 32px;
  width: 32px;
  display: flex;
  place-items: center;
  border-radius: 16px;
  background-color: ${colors('black.08')};
  border: 2px solid transparent;

  cursor: pointer;
  position: relative;

  transition: 0.2s ease-in-out;

  &.active,
  &:hover {
    transition: 0.2s ease-in-out;
    border-color: ${colors('primary.base')};
  }
`;
